// ==============================|| OVERRIDES - SELECT ||============================== //
// Padding/select layout; лейбл — InputLabel.js (+ backup ниже на FormControl).

export default function Select() {
  return {
    MuiFormControl: {
      styleOverrides: {
        root: {
          '&&.MuiFormControl-sizeSmall:has(.MuiSelect-root) .MuiInputLabel-root.MuiInputLabel-outlined:not(.MuiInputLabel-shrink)': {
            top: 0
          },
          '&&.MuiFormControl-sizeSmall:has(.MuiOutlinedInput-root:not(.MuiSelect-root)) .MuiInputLabel-root.MuiInputLabel-outlined:not(.MuiInputLabel-shrink)': {
            top: 0
          }
        }
      }
    },
    MuiSelect: {
      styleOverrides: {
        select: {
          display: 'flex',
          alignItems: 'center',
          lineHeight: 1.4375
        },
        root: {
          '&.MuiOutlinedInput-root.MuiInputBase-sizeSmall .MuiSelect-select': {
            padding: '7.5px 32px 7.5px 12px'
          },
          '&.MuiOutlinedInput-root:not(.MuiInputBase-sizeSmall) .MuiSelect-select': {
            padding: '10.5px 32px 10.5px 14px'
          }
        }
      }
    }
  };
}
